import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiAlertTriangle, FiArrowRight, FiWifiOff } from "react-icons/fi";

import SEO from "../SEO/SEO";

export default function ErrorPage() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <>
      <SEO
        title="Page not found"
        description="The page you are looking for is unavailable."
        path="/404"
      />

      <section className="error-state">
        <div className="section-shell error-state__content">
          <div className="error-state__icon" aria-hidden="true">
            {isOnline ? <FiAlertTriangle /> : <FiWifiOff />}
          </div>
          <p className="section-kicker">Navigation issue</p>
          <h1>{isOnline ? "We could not find that page." : "Connection looks interrupted."}</h1>
          <p>
            {isOnline
              ? "The route may have moved during the redesign. You can head back to the homepage or contact us directly."
              : "Please check your network and try again. The contact team is still available once the connection is back."}
          </p>
          <div className="button-group">
            <Link to="/" className="button button-primary">
              Return home
              <FiArrowRight aria-hidden="true" />
            </Link>
            <Link to="/contact" className="button button-secondary">
              Contact Thamizhi
              <FiArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
